// Strand Reporting Dashboard JavaScript
// Note: Chart tabs functionality is now handled by AcademicsDashboard in _academics_dashboard_new.slim
// This file is kept for potential future strand-specific functionality

$(document).on('turbolinks:load', function() {
  // Strand reporting specific functionality can be added here if needed
  console.log('Strand Reporting JavaScript loaded');
});

// Helper function to animate the rotated bars (if needed)
function animateRotatedBars() {
  $('.rotated-bar-segment').each(function(index) {
    const $segment = $(this);
    const finalHeight = $segment.css('height');
    
    // Start with height 0 and animate to final height
    $segment.css('height', '0px');
    
    setTimeout(function() {
      $segment.animate({
        height: finalHeight
      }, 500 + (index * 100)); // Stagger animation
    }, 200);
  });
}

// Export functions for potential use elsewhere
window.StrandReporting = {
  animateRotatedBars: animateRotatedBars
};